import {FC, Link, useMemo} from 'external/react'
import Icon from 'external/fortawesome'
import { User } from 'types/context/parent'
import useParent from 'context/parent-context/hook'
import { clsx } from 'external/clsx'

export type UserCardFooterProps = {
    user: User
    onDeleteClick?: (user: User) => void
}

const UserCardFooter: FC<UserCardFooterProps> = props => {
    const {navigation, params: {role}} = useParent()
    const { user, onDeleteClick } = props
    const detailsDisabled = useMemo(() => user.packages === 0, [user.packages])
    return (
        <div className='row' style={{ padding: '0px 10px' }} >
            <div className='col-md-10 col-sm-10 col-10'>
                <Link aria-disabled={detailsDisabled} to={navigation.userPackages.link({role: role || '', userId: user.id})} className={clsx('btn btn-outline-primary w-100 btn-sm', {'disabled': detailsDisabled})} >Detalles</Link>
            </div>
            <div className='col-md-2 col-sm-2 col-2 m-auto text-center'>
                <span className='span--delete' title='eliminar' >
                    <Icon name='faTrashCan' onClick={() => onDeleteClick && onDeleteClick(user) }/>
                </span>
            </div>
        </div>
    )
}
    
export {UserCardFooter as default}